import { Routes, RouterModule } from '@angular/router';

import { CharacterSheetsComponent } from './character-sheets/character-sheets.component';
import { CharacterSheetComponent } from './character-sheet/character-sheet.component';
import { AuthGuard } from './guard/auth.guard';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { CharacterSheetsCreateComponent } from './character-sheets/create/create.component';
import { CharacterSheetPrintComponent } from './character-sheet/print/print.component';
import { DashboardUpdateComponent } from './dashboard/update/dashboard.update.component';
import { AdminComponent } from './admin/admin.component';
import { AdminSetCrimsonComponent } from './admin/setCrimson/setCrimson.component';
import { AdminListReportComponent } from './admin/listReport/listReport.component';
import { AdminListLogComponent } from './admin/listLog/listLog.component';
import { AdminDatadumpPersonnageComponent } from './admin/datadumpPersonnage/datadumpPersonnage.component';
import { AdminDesinscriptionComponent } from './admin/desinscription/desinscription.component';
import { AdminCompetencesComponent } from './admin/competences/competences.component';
import { AdminSortsComponent } from './admin/sorts/sorts.component';
import { AdminFichePersonnageComponent } from './admin/fichePersonnage/fichePersonnage.component';
import { AdminListeFichePersonnageComponent } from './admin/listeFichePersonnage/listeFichePersonnage.component';

const routes: Routes = [
    { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
    { path: 'sign-in', component: SignInComponent },
    { path: 'register-user', component: SignUpComponent },
    { path: 'dashboard', component: DashboardComponent },
    { path: 'dashboard/update', component: DashboardUpdateComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'verify-email-address', component: VerifyEmailComponent },
    { path: 'characterSheets', component: CharacterSheetsComponent},    
    { path: 'characterSheets/create', component: CharacterSheetsCreateComponent},
    { path: 'characterSheets/:characterSheetId', component: CharacterSheetComponent},
    { path: 'characterSheets/:characterSheetId/Print', component: CharacterSheetPrintComponent},
    { path: 'admin', component: AdminComponent},
    { path: 'admin/datadumpPersonnage', component: AdminDatadumpPersonnageComponent},
    { path: 'admin/setCrimson', component: AdminSetCrimsonComponent},
    { path: 'admin/desinscription', component: AdminDesinscriptionComponent},
    { path: 'admin/listReport', component: AdminListReportComponent},
    { path: 'admin/listLog', component: AdminListLogComponent},
    { path: 'admin/sorts', component: AdminSortsComponent},
    { path: 'admin/competences', component: AdminCompetencesComponent},
    { path: 'admin/fichePersonnage/:characterSheetId', component: AdminFichePersonnageComponent},
    { path: 'admin/listeFichePersonnage', component: AdminListeFichePersonnageComponent},

    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

export const appRoutingModule = RouterModule.forRoot(routes);